import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gift-cards/giftcard-dual.png")